// Static imports for all background images to prevent iOS memory leaks
// Dynamic imports cause memory issues on iOS Safari during rapid swipes
import basketballBg from './basketball-background.jpg';
import baseballBg from './baseball-background.jpg';
import soccerBg from './soccer-background.jpg';
import footballBg from './football-background.jpg';
import hockeyBg from './hockey-background.jpg';
import tennisBg from './tennis-background.jpg';
import golfBg from './golf-background.jpg';
import horseracingBg from './horseracing-background.jpg';
import basicBg from './basic-background.jpg';
import basicDaBg from './basic-background-da.jpg';
import sportBg from './sport-background.jpg';

export const backgroundImages = {
  'basketball-background': basketballBg,
  'baseball-background': baseballBg,
  'soccer-background': soccerBg,
  'football-background': footballBg,
  'hockey-background': hockeyBg,
  'tennis-background': tennisBg,
  'golf-background': golfBg,
  'horseracing-background': horseracingBg,
  'basic-background': basicBg,
  'basic-background-da': basicDaBg,
  'sport-background': sportBg,
};
